import { render, staticRenderFns } from "./VxUserBreadcrumb.vue?vue&type=template&id=1f94cf2c&functional=true&"
import script from "./VxUserBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxUserBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports